import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

import { FileSelectPreviewFile } from "@/components/ui-v2/FileSelectPreviewList/types";

import { FileSelectPreviewListAudioTile } from "./FileSelectPreviewListAudioTile";
import { FileSelectPreviewListImageTile } from "./FileSelectPreviewListImageTile";
import { FileSelectPreviewListMeshTile } from "./FileSelectPreviewListMeshTile";
import { FileSelectPreviewListVideoTile } from "./FileSelectPreviewListVideoTile";

export interface FileSelectPreviewListTileProps {
  file: FileSelectPreviewFile;
  isEditable?: boolean;
  renderFooter?: () => React.ReactNode;
  onAction: (event: React.MouseEvent, action: string) => void;
}

const Root = styled(Box)(({ theme }) => ({
  position: "relative",
  backgroundColor: theme.palette.secondary[5],
  borderRadius: 8,
  padding: theme.spacing(1),
}));

export const FileSelectPreviewListTile = (
  props: FileSelectPreviewListTileProps,
) => {
  const { file, isEditable = false, renderFooter, onAction, ...rest } = props;

  let tile = null;

  if (file.type === "audio") {
    tile = (
      <FileSelectPreviewListAudioTile
        key={file.thumbnailSrc}
        url={file.thumbnailSrc}
        onAction={onAction}
        // sx={tileSx}
      />
    );
  } else if (file.type === "video") {
    tile = (
      <FileSelectPreviewListVideoTile
        src={file.thumbnailSrc}
        onAction={onAction}
        // sx={tileSx}
      />
    );
  } else if (file.type === "mesh") {
    tile = (
      <FileSelectPreviewListMeshTile
        url={file.thumbnailSrc}
        onAction={onAction}
      />
    );
  } else {
    const cropWindow = file.transform?.crop;

    tile = (
      <FileSelectPreviewListImageTile
        src={file.thumbnailSrc}
        onAction={onAction}
        cropWindow={cropWindow}
        isEditable={isEditable}
        // sx={tileSx}
      />
    );
  }
  const footer = renderFooter ? renderFooter() : null;

  if (!footer) {
    return tile;
  }

  return (
    <Root
      data-testid="file-select-preview-list-tile"
      data-object-id={file.id}
      data-object-type={file.type}
      {...rest}
    >
      {tile}
      {footer}
    </Root>
  );
};
